import { defineComponent as _defineComponent } from 'vue'
import type { VideoV1 } from '@ilteducation/content-registry-types';
import CoverArrayInput from '@/components/collections/CoverArrayInput.vue';
import { getSelectedContent, putSelectedContent } from '@/data-provider/contentMatching';
import { computed, onMounted, ref } from 'vue';
import { ContentMatchesSelectionItem } from '@ilteducation/content-matching-types';
import eventBus from '@/foundations/services/eventBus';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoSimilarContent',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as { item: VideoV1 }


const contentMatchesSelection = ref<ContentMatchesSelectionItem>();

const blacklistedContent = ref<{ id: string; type: string }[]>([]);
const whitelistedContent = ref<{ id: string; type: string }[]>([]);

const isBlacklistEdited = computed(() => {
  return (
    (contentMatchesSelection.value &&
      contentMatchesSelection.value.excluded?.length !== blacklistedContent.value.length) ||
    blacklistedContent.value.some((article) => !contentMatchesSelection.value?.excluded?.includes(article.id))
  );
});

const isWhitelistEdited = computed(() => {
  return (
    (contentMatchesSelection.value &&
      contentMatchesSelection.value.included?.length !== whitelistedContent.value.length) ||
    whitelistedContent.value.some((article) => !contentMatchesSelection.value?.included?.some(item => item.id === article.id))
  );
});

const isRelatedContentEdited = computed(() => {
  return isBlacklistEdited.value || isWhitelistEdited.value;
});
const isSaving = ref(false);
const isLoading = ref(false);

const saveRelatedContentUpdates = async () => {
  if (isLoading.value || !isRelatedContentEdited.value || isSaving.value) {
    return;
  }
  isSaving.value = true;
  await putSelectedContent({
    ...(contentMatchesSelection.value || { contentId: props.item.id, type: 'Video' }),
    included: whitelistedContent.value.map((content) => content.id),
    excluded: blacklistedContent.value.map((content) => content.id),
  });
  eventBus.$emit('snackbar.open', `Related content for video ${props.item.id} saved`);
  await loadSelectedContent();
  isSaving.value = false;
};

const loadSelectedContent = async () => {
  isLoading.value = true;
  try {
    const contentSelections = await getSelectedContent(props.item.id);
    contentMatchesSelection.value = contentSelections;
    blacklistedContent.value = contentSelections.excluded?.map((id) => ({ id, type: 'Article' })) || [];
    whitelistedContent.value = contentSelections.included?.map((item) => ({ id: item.id, type: 'Article' })) || [];
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  await loadSelectedContent();
});

return { __sfc: true,props, contentMatchesSelection, blacklistedContent, whitelistedContent, isBlacklistEdited, isWhitelistEdited, isRelatedContentEdited, isSaving, isLoading, saveRelatedContentUpdates, loadSelectedContent, CoverArrayInput }
}

})